import lendmarqLogo from "../../../assets/logos/lendmarq-logo.png"; // Adjust the path as necessary
import PdfImage from "./images/PdfImage";

// Cache the PNG so we only convert once
const PdfBuilderLogo = ({ width, height, size = 32, style = {} }) => {
  return (
    <PdfImage
      src={lendmarqLogo}
      width={width} // undefined by default = auto
      height={height || size}
      style={{
        objectFit: "contain",
        ...style,
      }}
    />
  );
};
export default PdfBuilderLogo;
